import { type IconName } from '@garnish/core';

import { CardType } from '@sg/graphql-schema';

import { type PaymentMethod } from '../machine/scan-to-pay.machine.types';

export const PAYMENT_METHOD_ICON_MAP = {
  [CardType.Visa]: 'IconCcVisa',
  [CardType.AmericanExpress]: 'IconCcAmex',
  [CardType.Amex]: 'IconCcAmex',
  [CardType.Discover]: 'IconCcDiscover',
  [CardType.MasterCard]: 'IconCcMasterCard',
  [CardType.Unsupported]: 'IconCreditCard',
} satisfies Record<CardType, IconName>;

export const getDefaultPaymentMethodId = (paymentMethods: readonly PaymentMethod[]) => {
  return paymentMethods.find((pm) => pm.isDefault)?.id ?? paymentMethods[0]?.id ?? '';
};
